import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold tracking-[0.01em] transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground',
        success: 'border-transparent bg-success text-success-foreground',
        warning: 'border-transparent bg-warning text-warning-foreground',
        info: 'border-transparent bg-info text-info-foreground',
        outline: 'border-border text-foreground',
        muted: 'border-transparent bg-muted text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export function Badge({ className, variant, ...props }) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

// Map between RFQ status enum and badge variant
const RFQ_STATUS_VARIANTS = {
  in_preparation: 'muted',
  in_analysis: 'info',
  awaiting_logistics: 'warning',
  awaiting_commercial_margins: 'secondary',
  awaiting_finance: 'warning',
  awaiting_direction: 'secondary',
  awaiting_admin: 'secondary', // legacy — kept for rows not yet migrated
  approved: 'success',
  offer_sent: 'info',
  won: 'success',
  lost: 'destructive',
  in_negotiation: 'warning',
};

export function statusBadgeVariant(status) {
  return RFQ_STATUS_VARIANTS[status] || 'outline';
}
